import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'
import { OrigenesContabilidadConstant } from 'constants/index'

const PlantillaFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const [plantillasOptions, setPlantillasOptions] = React.useState([])

  React.useEffect(() => {
    PlantillaContabilidadService.getxOrigenAsSelect(OrigenesContabilidadConstant.VENTAS).then(({ data }) => {
      if (data && data.length > 0) {
        const primeraOpcion = data[0]
        setFieldValue('idPlantilla', primeraOpcion._id)

        setPlantillasOptions(
          data.map((x, k) => (
            <option key={k} value={x._id}>
              {x.descripcion}
            </option>
          ))
        )
      }
    })
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='PLANTILLA' htmlFor='select-plantilla' md={12} />
      <Col md={12}>
        <Field name='idPlantilla'>
          {({ field }) => (
            <Form.Select {...field} id='select-plantilla' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>Seleccionar</option>
              {plantillasOptions}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlantillaFormGroup)
